import BrandSubscriptionServiceCallState from '../store/schema/BrandSubscriptionServiceCallState';

import {
    getBrandsSubscriptionsService,
    GetBrandsSubscriptionsServiceResponse,
} from 'owa-brands-subscription';
import { orchestrator } from 'satcheljs';
import {
    loadBrandsSubscriptions,
    setServiceCallState,
    updateBrandsSubscriptions,
} from '../actions/internalActions';

orchestrator(loadBrandsSubscriptions, async actionMessage => {
    setServiceCallState(BrandSubscriptionServiceCallState.InProgress);
    const response: GetBrandsSubscriptionsServiceResponse = await getBrandsSubscriptionsService();
    if (response) {
        updateBrandsSubscriptions(response);
        setServiceCallState(BrandSubscriptionServiceCallState.Succeeded);
    } else {
        setServiceCallState(BrandSubscriptionServiceCallState.Failed);
    }
});
